<template>
    <div class="p-0 m-0">
        <b-row class="mb-2" align-v="end">
            <b-col cols="12" md="2" v-if="!noPageSize">
                <app-form-select :options="pageOptions" v-model="perPage" size="sm" label="Por página" id="perPageSelect"></app-form-select>
            </b-col>

            <!-- <b-col cols="12" md="3" offset-md="7" lg="2" offset-lg="8"> -->
            <b-col class="d-flex justify-content-end">
                <slot name="buttons"></slot>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-table
                    v-if="!dataLoaded || total > 0 || (!!items && items.length > 0)"
                    :items="theItems"
                    :fields="theFields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    v-bind="$attrs"
                    v-on="$listeners"
                    responsive
                    :id="id"
                    striped
                    stacked="sm"
                >
                    <template #table-busy v-if="skeletonBusy">
                        <b-skeleton-table :rows="2" :columnas="4" :table-props="{ bordered: true, striped: true }"> </b-skeleton-table>
                    </template>
                    <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
                        <slot :name="slot" v-bind="scope" />
                    </template>
                </b-table>
                <b-alert variant="info" v-else show>Aún no hay información registrada, pronto la encontrarás. </b-alert>

                <!-- Mobile displays -->
                <!-- <div class="d-block d-md-none my-3">
                    hola
                    <b-list-group>
                        <b-list-group-item v-for="(item, index) in tableData" :key="index">
                            <table>
                                <tr v-for="field in mobileFields" :key="field.key">
                                    <td><strong>{{field.label}}</strong></td>
                                    <td>{{item[field.key]}}</td>
                                </tr>
                            </table>
                        </b-list-group-item>
                    </b-list-group>
                </div> -->

                <b-pagination
                    v-if="!noPagination"
                    v-model="currentPage"
                    :total-rows="total"
                    :per-page="perPage"
                    aria-controls="my-table"
                    align="center"
                ></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        fields: {
            // Campos que se muestran en el encabezado de la tabla
            type: Array,
            default: () => [],
        },
        resource: {
            // Recurso que se quiere consultar a traves de un servicio REST
            type: String,
        },
        with: {
            // Relaciones que se quieren incluir en la consulta
            type: String,
        },
        id: {
            type: String,
            default: () => `table-${parseInt(Math.random() * 1000000)}`,
        },
        actions: {
            // Bandera que indica si se agrega el slot actions a la tabla
            type: Boolean,
            default: false,
        },
        hardFilters: {
            // Filtros que se aplican por defecto a todas las consultas a traves del provider
            type: Object,
        },
        items: {
            type: Array,
            required: false,
        },
        noPagination: {
            type: Boolean,
            default: false,
        },
        noPageSize: {
            type: Boolean,
            default: false,
        },
        rowDetails: {
            type: Boolean,
            default: false,
        },
        skeletonBusy: {
            type: Boolean,
            default: true,
        },
        mutator: {
            type: Function,
        },
    },
    data: () => ({
        currentPage: 1,
        total: 0,
        perPage: 10,
        pageOptions: [10, 30, 50, 100],
        tableData: [],
        dataLoaded: false,
    }),
    computed: {
        theFields() {
            const fields = this.breakpoint === 'xs' ? this.fields.filter((item) => !(item.xshidden || false)) : this.fields
            return this.actions ? [...fields, actions] : fields
        },
        theItems() {
            return _.isEmpty(this.items) ? this.dataProvider : this.items
        },
        mobileFields() {
            return this.fields.filter((item) => !!item.mobile)
        },
    },
    methods: {
        async dataProvider(ctx) {
            if (!this.resource) return
            let params = { ...ctx }
            const field = this.fields.find((item) => item.key === ctx.sortBy)
            !!field && !!field.hasOwnProperty('sortKey') && (params.sortBy = field.sortKey)
            delete params.filter
            !!this.with && (params.with = this.with)
            const filters = !!ctx.filter ? _.pickBy(ctx.filter, _.identity) : {}
            !!ctx.filter && (params = { ...params, ...filters })
            !!this.hardFilters && (params = { ...params, ...this.hardFilters })
            const { data } = await this.$repo.get(this.resource, params)
            this.dataLoaded = true
            this.$emit('data-loaded', data)
            this.currentPage = data.current_page ?? data.meta?.current_page ?? 1
            this.total = data.total ?? data.meta.total
            this.perPage = data.per_page ?? data.meta.per_page

            const tableData = this.rowDetails
                ? data.data.map((item) => ({
                      ...item,
                      _rowDetails: this.rowDetails,
                  }))
                : data.data

            if (!!this.mutator) {
                return tableData.map((item) => this.mutator(item))
            }
            return tableData
        },
        refresh() {
            this.dataLoaded = false
            this.$root.$emit('bv::refresh::table', this.id)
        },
    },
}
const actions = {
    key: 'actions',
    label: 'Acciones',
}
</script>
